import React from "react";

const DashboardMetricBar = ({ value = 0, tone = "neutral", label }) => {
  const clamped = Math.min(100, Math.max(0, value));

  return (
    <div className="dashboard-metric-bar" role="meter" aria-valuenow={clamped} aria-valuemin={0} aria-valuemax={100} aria-label={label}>
      <div className="dashboard-metric-bar-track">
        <div
          className={`dashboard-metric-bar-fill tone-${tone}`}
          style={{ width: `${clamped}%` }}
        />
      </div>
      <span className={`dashboard-metric-bar-value tone-${tone}`}>{clamped}%</span>
    </div>
  );
};

export default DashboardMetricBar;
